export default __webpack_public_path__ + "static/media/alert.5ea22e09.svg";